import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-cream" data-id="element-163">
      <div className="max-w-3xl mx-auto text-center" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-8" data-id="element-165">
          <p className="text-amber font-semibold tracking-widest uppercase text-sm" data-id="element-166">
            Introducing
          </p>
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal leading-tight" data-id="element-167">
            The Meltdown Vault:
            <br data-id="element-168" />
            <span className="text-amber" data-id="element-169">Crisis Calm Method</span>
          </h2>

          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-cream-dark my-12" data-id="element-170">
            <h3 className="text-2xl md:text-3xl font-serif text-charcoal mb-6" data-id="element-171">
              The 5-Minute Crisis Calm: How to Stop Meltdowns and Restore Peace
              at Home in 30 Days — Without Fighting, Forcing or Burning Out
            </h3>
            <div className="w-16 h-1 bg-amber mx-auto mb-8 rounded-full" data-id="element-172"></div>
            <div className="space-y-6 text-lg text-charcoal-light text-left leading-relaxed" data-id="element-173">
              <p data-id="element-174">
                This is not a parenting philosophy. This is not a collection of
                inspirational quotes about neurodiversity. This is not another
                book that makes you feel understood but leaves you with nothing
                concrete to do at 6:52 PM on a Tuesday.
              </p>
              <p className="text-2xl font-serif text-charcoal text-center py-4" data-id="element-175">
                This is a field manual.
              </p>
              <p data-id="element-176">
                Built specifically for parents of autistic children ages 3 to
                12. Written in plain language. Organized for parents who are
                already exhausted and need the protocol, not the theory.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}